export default __webpack_public_path__ + "static/media/negetiveBankIndexRate.5f6d2353.svg";